var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          d: "M24 9L14 .5V22h2.5a1.5 1.5 0 001.5-1.5v-10A1.5 1.5 0 0119.5 9H24z",
          fill: "#037889",
        },
      }),
      _c("path", {
        attrs: {
          opacity: ".5",
          d: "M7.5 2A1.5 1.5 0 006 3.5v10A1.5 1.5 0 014.5 15H0l10 8.5V2H7.5z",
          fill: "#037889",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }